<template>
  <div id="footer">
    <div style="display: flex;align-items: center;flex-direction: column;width: 65%;">
      <img src="../assets/image/top-logo.png" alt="" srcset="" />
      <div class="content">
        <div style="text-align: center; line-height: 180%">
          <div>工作时间：早上8:00-凌晨2:00</div>
          <div>Copyright@2015-2026 山东远古信息科技有限公司</div>
          <div>举报邮箱：ygkj@nuanyuqingnan.cn</div>
          <div>鲁ICP备2025142152号</div>
        </div>
        <div class="code">
          <img src="../assets/image/code.jpg" alt="" />
          <div>扫码关注微信公众号</div>
        </div>
        <div class="code">
          <img src="../assets/image/code.jpg" alt="" />
          <div>扫码下载暖语轻喃APP</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
#footer {
  background: #2abbb4;
  padding: 30px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#footer img {
  width: 100px;
}
.content {
  padding:60px;
  border-top: 1px solid #6ad0cb;
  margin-top: 20px;
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.code{
  text-align: center;
}
</style>
